<template>
    <router-view></router-view>
</template>

<script>

export default {
    name: 'devices',
    data() {
        return {
        }
    },
    methods: {

    },
    components: {
    }
};
</script>

<style lang="scss" scoped>

</style>
